import React from "react";
import PublicNav from "../components/PublicNav";
import PublicFooter from "../components/PublicFooter";

const sections = [
  {
    title: "1. Responsable du traitement",
    body: (
      <>
        MmeValentine est responsable du traitement des données personnelles
        décrites ci-dessous. Pour toute question relative à vos données,
        contactez-nous à{" "}
        <a href="mailto:support@activate.mmevalentine.com" className="text-rouge underline underline-offset-2">
          support@activate.mmevalentine.com
        </a>
        .
      </>
    ),
  },
  {
    title: "2. Données collectées",
    body: (
      <>
        <strong>Compte :</strong> email, nom, statut d'abonnement — gérés via
        notre prestataire d'authentification <strong>Clerk</strong>.
        <br className="hidden sm:block" />
        <strong> Données LinkedIn :</strong> lorsque vous connectez votre
        compte LinkedIn via notre partenaire <strong>Unipile</strong>, nous
        accédons aux informations nécessaires au fonctionnement du Service :
        identité de profil, liste de contacts et de profils recherchés,
        historique des actions effectuées (visites, invitations, messages) et
        leur statut.
        <br className="hidden sm:block" />
        <strong> Données d'usage :</strong> segments créés, instructions
        fournies à l'IA, journal d'activité du Service.
      </>
    ),
  },
  {
    title: "3. Finalités du traitement",
    body: (
      <>
        Ces données sont utilisées pour : fournir et sécuriser l'accès au
        Service, exécuter les actions d'activation LinkedIn que vous
        configurez, générer des messages personnalisés via l'intelligence
        artificielle, afficher votre tableau de bord et votre historique
        d'activité, et gérer votre abonnement.
      </>
    ),
  },
  {
    title: "4. Base légale",
    body: (
      <>
        Le traitement repose sur l'exécution du contrat qui vous lie à
        MmeValentine (fourniture du Service) et, le cas échéant, sur votre
        consentement explicite lors de la connexion de votre compte LinkedIn.
      </>
    ),
  },
  {
    title: "5. Sous-traitants et hébergement",
    body: (
      <>
        Nous faisons appel aux prestataires suivants pour fournir le
        Service : <strong>Clerk</strong> (authentification et gestion des
        abonnements), <strong>Unipile</strong> (accès à l'API LinkedIn) et
        notre fournisseur d'infrastructure d'hébergement. Ces prestataires
        n'utilisent vos données que pour le compte de MmeValentine et dans le
        cadre de la fourniture du Service.
      </>
    ),
  },
  {
    title: "6. Stockage et conservation",
    body: (
      <>
        Les données propres au Service (segments, contacts, historique
        d'activité) sont stockées dans une base de données{" "}
        <strong>SQLite</strong> hébergée sur notre infrastructure. Elles sont
        conservées pendant toute la durée de votre compte, puis supprimées
        dans un délai maximum de 90 jours après la clôture de celui-ci, sauf
        obligation légale de conservation plus longue.
      </>
    ),
  },
  {
    title: "7. Sécurité",
    body: (
      <>
        L'accès à votre compte LinkedIn est chiffré et géré exclusivement via
        Unipile ; votre mot de passe LinkedIn n'est jamais stocké sur nos
        serveurs. L'accès au Service est protégé par l'authentification
        Clerk. Nous limitons l'accès aux données au strict nécessaire pour le
        fonctionnement du Service.
      </>
    ),
  },
  {
    title: "8. Vos droits",
    body: (
      <>
        Conformément au Règlement Général sur la Protection des Données
        (RGPD), vous disposez d'un droit d'accès, de rectification,
        d'effacement, de limitation et d'opposition au traitement de vos
        données, ainsi que d'un droit à la portabilité. Vous pouvez exercer
        ces droits en nous écrivant à{" "}
        <a href="mailto:support@activate.mmevalentine.com" className="text-rouge underline underline-offset-2">
          support@activate.mmevalentine.com
        </a>
        . Vous pouvez également déconnecter votre compte LinkedIn à tout
        moment depuis votre tableau de bord.
      </>
    ),
  },
  {
    title: "9. Cookies",
    body: (
      <>
        Le Service utilise uniquement les cookies techniques nécessaires à
        l'authentification, déposés par Clerk. Aucun cookie publicitaire ou
        de suivi tiers n'est utilisé.
      </>
    ),
  },
  {
    title: "10. Modification de cette politique",
    body: (
      <>
        Cette politique de confidentialité peut être mise à jour ; toute
        modification substantielle vous sera communiquée par email ou via le
        Service.
      </>
    ),
  },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-cream font-sans flex flex-col">
      <PublicNav />

      <main className="flex-1 max-w-2xl w-full mx-auto px-4 lg:px-8 py-14">
        <div className="mb-10">
          <p className="type-label-accent">Document légal</p>
          <h1 className="mt-3 font-display text-3xl font-bold tracking-tight text-ink">
            Politique de confidentialité
          </h1>
          <p className="mt-2 text-sm text-mute">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long" })}</p>
        </div>

        <div className="card p-8 space-y-8">
          {sections.map((s) => (
            <div key={s.title}>
              <h2 className="font-display font-semibold text-ink tracking-tight mb-2">
                {s.title}
              </h2>
              <p className="text-sm text-ink/70 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </main>

      <PublicFooter />
    </div>
  );
}
